import React, { useState } from 'react';
import { Drawer, Box, IconButton, Tooltip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { EventTemplates } from 'components/EventTemplates';
import { getEvents } from 'repositories/HttpRepository';
import { EVENT_TEMPLATE_OWNERS, EVENT_TEMPLATE_TARGETS } from 'constants/eventTemplate';
import { useRecoilValue } from 'recoil';
import { selectedRegionState } from '../../../atoms/Forecast';
import { sanitizeRegionCode } from '../../../utils/sanitization';

// Keep this trick until we don't support merge regions like CHI,MKE.
const handleRegionCodeForSpecialCase = (region) => {
  const REGION_MAPPING = {
    CHI: 'CHI,MKE',
    MKE: 'CHI,MKE',
  };
  return REGION_MAPPING[region] || region;
};

const History = () => {
  const [isOpenHistory, setIsOpenHistory] = useState(false);
  const selectedRegion = useRecoilValue(selectedRegionState);

  const handleDisplayHistory = (val) => {
    setIsOpenHistory(val);
  };

  return (
    <>
      <Tooltip title="Forecast History">
        <IconButton aria-label="forecast-history" onClick={() => handleDisplayHistory(true)} disabled={!selectedRegion} size="small">
          <HistoryIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {isOpenHistory && (
        <Drawer
          anchor="right"
          open={isOpenHistory}
          onClose={() => handleDisplayHistory(false)}
          slotProps={{
            paper: {
              sx: { width: 500 },
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              m: 2,
              justifyContent: 'center',
              fontWeight: 700,
              fontFamily: 'AvenirNext',
            }}
          >
            Forecast History - {selectedRegion}
          </Box>

          <EventTemplates
            getEventList={getEvents}
            historyId={(() => {
              try {
                const sanitizedRegion = sanitizeRegionCode(selectedRegion);
                return `RG_${handleRegionCodeForSpecialCase(sanitizedRegion)}`;
              } catch (error) {
                // console.error('Invalid region code:', error.message);
                return null;
              }
            })()}
            targets={[EVENT_TEMPLATE_TARGETS.DASHBOARD_APP]}
            owners={[EVENT_TEMPLATE_OWNERS.FORECAST]}
            urlParams={{ rel: true, ref: false }}
            filterEvent={(event) => event.category === 'FORECAST'}
          />
        </Drawer>
      )}
    </>
  );
};

export default History;
